import type { ITableSettings } from "../types";
import {
  evaluateCalculation,
  rawCalculationResult,
} from "./evaluate-calculation";
import { getHeaderRowIndex } from "./get-header-row-index";
import { parseSortableValue } from "./parse-sortable-value";
import { makeCellResolver } from "./resolve-cell-text";

export type ColumnKind = "number" | "text";

export const deriveColumnKind = (
  settings: Pick<
    ITableSettings,
    | "tableData"
    | "tableCols"
    | "tableRows"
    | "tableHasHeader"
    | "tableHeaderPosition"
  >,
  col: number,
): ColumnKind => {
  const {
    tableData,
    tableCols,
    tableRows,
    tableHasHeader,
    tableHeaderPosition,
  } = settings;
  if (!tableData || col < 0 || col >= tableCols) return "text";

  const headerRow = getHeaderRowIndex({
    tableRows,
    tableHasHeader,
    tableHeaderPosition,
  });

  const { resolveText } = makeCellResolver(tableData);
  let hasAny = false;
  for (let row = 0; row < tableRows; row++) {
    if (row === headerRow) continue;
    const cell = tableData[col + row * tableCols];
    // Evaluate calc cells so numeric results detect as "number" (run before resolveText).
    const text = cell?.calculation?.formula
      ? rawCalculationResult(
          evaluateCalculation(cell.calculation.formula, {
            tableData,
            tableCols,
            tableRows,
            cellCoord: { col, row },
          }),
        )
      : resolveText(cell);
    if (!text) continue;
    hasAny = true;
    if (parseSortableValue(text).kind !== "number") return "text";
  }
  return hasAny ? "number" : "text";
};
